import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import ReportsAPI from './../../../../Reports/api/reports_api';
import NumberToLetters from './../../../../../utils/NumberToletters';
import { formatNumber } from '../../../../Utils/Money';

const generateDocDefTemplate2 = async (obj) => {
    console.log("DATAINVOICEPDF", obj);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const city = sessionStorage.getItem('id_ciudad');
    const dept = parseInt(sessionStorage.getItem('id_dpto'));
    const getCity = await ReportsAPI.loadCity(city);
    const getDepts = await ReportsAPI.loadDepartment();
    const deptoProfile = getDepts.find((depto) => depto.id === dept)
    console.log(deptoProfile)
    let invoiceNote = !!obj.nota ? obj.nota : "";

    let cityReport = getCity.length > 0 ? getCity[0].ciunom : ' ';
    let deptoReport = deptoProfile !== null ? deptoProfile.depnom : '';
    let cantItems = 0;
    for (var i = 0; i < obj.items.length; i++) {
        cantItems = cantItems + 1;
    }
    let emision = new Date(obj.fecha_emision);
    let expirationDate = obj.recibosCaja[0].diasvencimiento != null && obj.recibosCaja[0].diasvencimiento != undefined ? parseInt(obj.recibosCaja[0].diasvencimiento) : 30;
    //let expirationDateinvoice = new Date();
    let expirationDateinvoice = moment(emision).add(expirationDate, 'days').format("DD-MM-YYYY")
    let typeRegime = obj.recibosCaja[0].tipo_plan_regimen;

    let tipo_contribuyente = obj.profile.tipo_contribuyente !== null && obj.profile.tipo_contribuyente !== undefined ? obj.profile.tipo_contribuyente : 0;
    let name_contribuyente;
    switch (parseInt(tipo_contribuyente)) {
        case 1:
            name_contribuyente = 'PERSONA NATURAL'
            break;
        case 2:
            name_contribuyente = 'PERSONA JURIDICA'
            break;
        default:
            name_contribuyente = '';
            break;
    }

    let nameRegime = '';
    if (typeRegime !== null && typeRegime !== undefined && typeRegime !== '') {
        switch (parseInt(typeRegime)) {
            case 1:
                nameRegime = 'PARTICULAR';
                break;
            case 2:
                nameRegime = 'SUBSIDIADO';
                break;
            case 3:
                nameRegime = 'CONTRIBUTIVO';
                break;
            case 4:
                nameRegime = 'REGIMEN ESPECIAL';
                break;
            case 5:
                nameRegime = 'CONTRIBUTIVO COMPLEMENTARIO';
                break;
            case 6:
                nameRegime = 'SOAT';
                break;
            case 7:
                nameRegime = 'POLIZA';
                break;
            case 8:
                nameRegime = 'PARTICULAR MEDICINA PREPAGADA';
                break;
            case 9:
                nameRegime = 'OTROS';
                break;


            default:
                nameRegime = '';
                break;
        }
    }

    const conceptPayment = () => {
        let receipts = obj.recibosCaja;
        let conPayment = 0;
        for (let i = 0; i < receipts.length; i++) {
            const element = receipts[i];
            conPayment += parseInt(element.total);
        }
        return conPayment;
    }

    let num_contract = obj.recibosCaja[0].numero_contrato != null ? obj.recibosCaja[0].numero_contrato : '';
    let negType = obj.recibosCaja[0].tipo_negociacion_contrato == 1 ? 'Credito' : obj.recibosCaja[0].tipo_negociacion_contrato == 2 ? 'Contado' : obj.recibosCaja[0].tipo_negociacion_contrato == 3 ? 'Otros' : '';
    let numberTelOrCel = '';
    let existNumTel = obj.recibosCaja[0].telefono_paciente !== undefined && obj.recibosCaja[0].telefono_paciente !== null ? true : false;
    let existNumCel = obj.recibosCaja[0].celular_paciente !== null && obj.recibosCaja[0].celular_paciente !== undefined ? true : false;
    if (existNumTel && existNumCel) {
        numberTelOrCel = 'Tel/Cel: ' + obj.recibosCaja[0].telefono_paciente + ' / ' + obj.recibosCaja[0].celular_paciente;
    } else if (existNumTel === false && existNumCel === true) {
        numberTelOrCel = 'Cel: ' + obj.recibosCaja[0].celular_paciente;
    } else if (existNumTel === true && existNumCel === false) {
        numberTelOrCel = 'Tel:' + obj.recibosCaja[0].telefono_paciente;
    } else {
        numberTelOrCel = '';
    }

    let numAuthorization = obj.recibosCaja[0].codigo_autorizacion !== null && obj.recibosCaja[0].codigo_autorizacion !== undefined ? obj.recibosCaja[0].codigo_autorizacion : '';
    let patientBirhtday = moment(obj.recibosCaja[0].fec_nacimiento_paciente).format("DD-MM-YYYY");
    let entranceDate = moment(obj.fecha_ingreso).format("DD-MM-YYYY");
    let emitionDate = moment(obj.fecha_emision).format('DD/MM/YYYY');
    let wayPaymentContract = '';
    if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 1) {
        wayPaymentContract = 'Acuerdo Mutuo';
    } else if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 2) {
        wayPaymentContract = 'Efectivo';
    } else if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 3) {
        wayPaymentContract = 'Transferencia';
    } else {
        wayPaymentContract = '';
    }

    let contractType = '';
    if (obj.recibosCaja[0].tipo_contrato !== null && obj.recibosCaja[0].tipo_contrato === 1) {
        contractType = 'Por Evento';
    } else if (obj.recibosCaja[0].tipo_contrato !== null && obj.recibosCaja[0].tipo_contrato === 2) {
        contractType = 'Capitación';
    } else if (obj.recibosCaja[0].tipo_contrato !== null && obj.recibosCaja[0].tipo_contrato === 3) {
        contractType = 'PGP';
    } else {
        contractType = '';
    }

    //Tabla de Informacion Juridica
    let itemBodyInformation = [];
    let abrev_tipo_pago = "";
    if (obj.recibosCaja[0].tipo_pago !== null && obj.recibosCaja[0].tipo_pago !== undefined) {
        if (obj.recibosCaja[0].tipo_pago == "CUOTA MODERADORA") {
            abrev_tipo_pago = "CM";
        } else if (obj.recibosCaja[0].tipo_pago == "CUOTA DE RECUPERACIÓN") {
            abrev_tipo_pago = "CR";
        } else if (obj.recibosCaja[0].tipo_pago == "COPAGO" && (typeRegime !== 6 || typeRegime !== 4 || typeRegime !== 1)) {
            abrev_tipo_pago = "COPAGO";
        } else {
            abrev_tipo_pago = "";
        }
    }
    let telThird = obj.tercero.telefono !== null ? obj.tercero.telefono : '';
    let emailThrid = obj.tercero.correo !== null ? obj.tercero.correo : '';
    let tipDoc = obj.esFactura == true ? "Factura Electrónica de Venta" : "Cuenta de Cobro";
    let casilla1 =
        "Cliente: " + obj.tercero.nombre + "\n" +
        "Contrato: " + "No." + num_contract + "\n" +
        "NIT: " + obj.tercero.nit + "\n" +
        "Direccion: " + obj.tercero.direccion.direccion + "\n" +
        "Telefono: " + telThird + "\n" +
        "Email: " + emailThrid + "\n\n" +
        "Tipo de Negociación: " + negType + "\n" +
        "Tipo de Contrato: " + contractType + "\n" +
        "Medio de Pago: " + wayPaymentContract + "\n" +
        "Fecha de Vencimiento: " + expirationDateinvoice;
    let casilla2 =
        "Usuario: " + obj.recibosCaja[0].nombre_paciente + " \n" + 
        "Identificación: " + obj.recibosCaja[0].num_documento_paciente + "\n" + 
        "Fecha de Nacimiento: " + patientBirhtday + "\n" + 
        "Dirección: " + obj.recibosCaja[0].direccion_paciente.direccion + "\n" + numberTelOrCel + "\n" + 
        "Ciudad: " + obj.recibosCaja[0].direccion_paciente.ciudad /* + " Genero: " + obj.recibosCaja[0].paciente_genero */ + "\n" + 
        "Edad: " + obj.recibosCaja[0].edad /* + " Tipo Sangre: "+ obj.recibosCaja[0].tipo_sangre_paciente */ + "\n" + 
        "Régimen: " + obj.recibosCaja[0].regimen_paciente + "\n No. Admisión: " + obj.recibosCaja[0].id_admision + "\n" + 
        "Autorización: " + numAuthorization + "\nIngreso: " + entranceDate + "\n" + 
        abrev_tipo_pago;
    let casilla3 =
        tipDoc + "\n" +
        "Moneda: COP Colombia,pesos \n" +
        "No: " + obj.num_fac_ter + "\n" +
        "Fecha Emision: " + emitionDate + "\n\n" +
        "R-Caja: " + obj.recibosCaja[0].num_recibo + "\n\n" +
        "Total de lineas o items: " + cantItems + "\n";

       /*  itemBodyInformation.push(
            [{ text: 'Cliente: ', style: 'textInfoInvoice', bold: true }, { text: obj.tercero.nombre, style: 'textInfoInvoice' }, { text: "Usuario: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].nombre_paciente, style: 'textInfoInvoice', bold: true }, { text: tipDoc, style: 'textInfoInvoice', bold: true, colSpan: 2 }, ''],
            [{ text: 'Contrato: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: 'No. ' + num_contract, style: 'textInfoInvoice' }, { text: "Identificación: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].num_documento_paciente, style: 'textInfoInvoice', bold: true }, { text: 'Moneda: ', bold: true, alignment: "left" }, { text: 'COP Colombia,pesos', style: 'textInfoInvoice' }],
            [{ text: 'NIT: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: obj.tercero.nit, style: 'textInfoInvoice' }, { text: "Fecha de Nacimiento: ", style: 'textInfoInvoice', bold: true }, { text: patientBirhtday, style: 'textInfoInvoice', bold: true }, { text: 'No: ', bold: true, alignment: "left" }, { text: obj.num_fac_ter, style: 'textInfoInvoice', bold: true }],
            [{ text: 'Direccion: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: obj.tercero.direccion.direccion, style: 'textInfoInvoice' }, { text: "Dirección: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].direccion_paciente.direccion, style: 'textInfoInvoice', bold: true }, { text: 'Fecha Emision: ', bold: true, alignment: "left" }, { text: moment(obj.fecha_emision).format("DD-MM-YYYY"), style: 'textInfoInvoice' }],
            [{ text: 'Telefono: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: telThird, style: 'textInfoInvoice' }, { text: "Ciudad: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].direccion_paciente.ciudad, style: 'textInfoInvoice', bold: true }, '', ''],
            [{ text: 'Email: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: emailThrid, style: 'textInfoInvoice' }, { text: "Edad: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].edad, style: 'textInfoInvoice', bold: true }, { text: 'R-Caja: ', bold: true, alignment: "left" }, { text: obj.recibosCaja[0].num_recibo, style: 'textInfoInvoice' }],
            [{ text: 'Tipo de Negociación: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: negType, style: 'textInfoInvoice' }, { text: "Régimen: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].regimen_paciente, style: 'textInfoInvoice', bold: true }, '', ''],
            [{ text: 'Tipo de Contrato: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: contractType, style: 'textInfoInvoice' }, { text: "No. Admisión: ", style: 'textInfoInvoice', bold: true }, { text: obj.recibosCaja[0].id_admision, style: 'textInfoInvoice', bold: true }, { text: 'Total de lineas o items: ', bold: true, alignment: "left" }, { text: cantItems, style: 'textInfoInvoice' }],
            [{ text: 'Medio de Pago: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: wayPaymentContract, style: 'textInfoInvoice' }, { text: "Autorización:", style: 'textInfoInvoice', bold: true }, { text: numAuthorization, style: 'textInfoInvoice', bold: true }, '', ''],
            [{ text: 'Fecha de Vencimiento: ', style: 'textInfoInvoice', bold: true, alignment: "left" }, { text: expirationDateinvoice, style: 'textInfoInvoice' }, { text: "Ingreso", style: 'textInfoInvoice', bold: true }, { text: entranceDate, style: 'textInfoInvoice', bold: true }, '', '']
        ); */

        itemBodyInformation.push(
            [{ text: 'Cliente: ' + obj.tercero.nombre, style: 'textInfoInvoice'}, 
            { text: "Usuario: " + obj.recibosCaja[0].nombre_paciente, style: 'textInfoInvoice'}, 
            { text: tipDoc, style: 'textInfoInvoice'}],
            [{ text: 'Contrato: ' + 'No. ' + num_contract, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Identificación: " + obj.recibosCaja[0].num_documento_paciente, style: 'textInfoInvoice'}, 
            { text: 'Moneda: ' + 'COP Colombia,pesos', alignment: "left" }],
            [{ text: 'NIT: ' + obj.tercero.nit, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Fecha de Nacimiento: " + patientBirhtday, style: 'textInfoInvoice'}, 
            { text: 'No: ' + obj.num_fac_ter, alignment: "left", bold: true }],
            [{ text: 'Direccion: ' + obj.tercero.direccion.direccion, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Dirección: " + obj.recibosCaja[0].direccion_paciente.direccion, style: 'textInfoInvoice'}, 
            { text: 'Fecha Emision: ' + moment(obj.fecha_emision).format("DD-MM-YYYY"), alignment: "left" }],
            [{ text: 'Telefono: ' + telThird, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Ciudad: " + obj.recibosCaja[0].direccion_paciente.ciudad, style: 'textInfoInvoice'}, ''],
            [{ text: 'Email: ' + emailThrid, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Edad: " + obj.recibosCaja[0].edad, style: 'textInfoInvoice'}, 
            { text: 'R-Caja: ' + obj.recibosCaja[0].num_recibo, alignment: "left" }],
            [{ text: 'Tipo de Negociación: ' + negType, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Régimen: " + obj.recibosCaja[0].regimen_paciente, style: 'textInfoInvoice'}, ''],
            [{ text: 'Tipo de Contrato: ' + contractType, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "No. Admisión: " + obj.recibosCaja[0].id_admision, style: 'textInfoInvoice'}, 
            { text: 'Total de lineas o items: ' + cantItems, alignment: "left" }],
            [{ text: 'Medio de Pago: ' + wayPaymentContract, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Autorización: " + numAuthorization, style: 'textInfoInvoice'}, ''],
            [{ text: 'Fecha de Vencimiento: ' + expirationDateinvoice, style: 'textInfoInvoice', alignment: "left" }, 
            { text: "Ingreso: " + entranceDate + "\n" + abrev_tipo_pago, style: 'textInfoInvoice'}, '']
        );
  /*   itemBodyInformation.push([
        { text: casilla1, alignment: "left" },
        { text: casilla2, alignment: "left" },
        { text: casilla3, alignment: "left" },
    ]); */

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "#",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Codigo",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Descripcion",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "U.M",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Cantidad",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Precio U",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "IVA",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Dcto",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Total",
                style: "tableHeader",
                alignment: "center",
            },
        ],
    ];
    let itemArr = ["", "", "", "", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        let servicesPlusCups;
        let serv = [];
        for (let i = 0; i < obj.recibosCaja.length; i++) {
            for (let k = 0; k < obj.recibosCaja[i].servicios.servicios.length; k++) {
                serv.push({ ["cups"]: obj.recibosCaja[i].servicios.servicios[k].cupscod, ["nombre"]: obj.recibosCaja[i].servicios.servicios[k].nombre })

            }
        }
        console.log("ServiciosEncontrados", serv)
        //servicesPlusCups = serv.map((s)=>{element.descripcion === s.nombre});
        console.log("CUPS", servicesPlusCups);
        itemBody.push([
            { text: index + 1, alignment: "right" },
            { text: element.cupscod !== null ? element.cupscod : element.referencia, alignment: "center" },
            { text: element.descripcion, alignment: "center" },
            { text: element.um, alignment: "center" },
            { text: element.cantidad, alignment: "center" },
            { text: "$" + formatNumber(element.precio), alignment: "center" },
            { text: "0.00", alignment: "center" },
            { text: "0", alignment: "center" },
            { text: "$" + formatNumber(element.costo_total), alignment: "center" },
        ]);
    }

    //Tabla de Informacion Juridica
    let itemBodyObservation = [];
    let casilla1tot = "Observaciones: " + invoiceNote;
    itemBodyObservation.push([
        { text: casilla1tot, alignment: "left" }
    ]);

    //Tabla de Informacion Juridica
    let itemBodyTotals = [];

    let totalFactura = parseInt(obj.total) - parseInt(conceptPayment());

    itemBodyTotals.push(
        [
            { text: 'Subtotal', alignment: "left", bold: true },
            { text: '$' + formatNumber(obj.total.toString()), alignment: "left" }
        ],
        [
            { text: 'Cargos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Descuentos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Abonos CM | CR | COPAGOS', alignment: "left", bold: true },
            { text: '$' + formatNumber(conceptPayment()), alignment: "left" }
        ],
        [
            { text: 'Iva', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Total de la Operacion', alignment: "left", bold: true },
            { text: '$' + formatNumber(totalFactura), alignment: "left" }
        ]
    );


    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    const validateFooterAutorization = (obj) => {
        if (obj.esFactura == true) {
            let foot = {
                text: obj.autorizacion_text,
                fontSize: 9,
                alignment: "center"
            }
            return foot;
        }
        else {
            return null;
        }
    }

    const header = {
        margin: [0, 0, -20, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', 'auto', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                    fit: [180, 90],
                    alignment: 'center'
                },
                {
                    layout: 'noBorders',
                    table: {
                        body: [
                            [{ text: obj.profile.nombre, style: 'head', alignment: 'center' }],
                            [{ text: 'NIT: : ' + obj.profile.nit, style: 'texthead', alignment: 'center' }],
                            [{ text: name_contribuyente, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.direccion.direccion, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.telefono1, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.email, style: 'texthead', alignment: 'center' }],
                            [{ text: cityReport + ', ' + deptoReport, style: 'texthead', alignment: 'center' }],
                        ],
                        alignment: 'center',
                    },
                },
                {
                    width: "*",
                    columns: [
                        await propsQRCode(obj.urlDian)
                    ],
                    alignment: 'center'
                },],
            ],
        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [26, 25, 26, 20],
        info: {
            title: "Factura No#" + obj.num_fac_ter,
            author: "",
        },
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/
        /*
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                        },
                    ],
                },
            ];
        },
        */
        content: [
            header,
            {
                text: obj.cufe != null ? "\n\n CUFE/CUDE:" + obj.cufe : "\n\n",
                fontSize: 9,
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: ["*","*","*"],
                    heights: 0,
                    body: itemBodyInformation,
                },
                /* layout: "exampleLayout", */
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                    /* canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 285,
                            h: 130,
                            r: 5,
                            lineColor: 'black',
                        },
                    ], */
                },
                dontBreakRows: true,
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: [5, 30, 225, 30, 20, 50, 20, 20, 50],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                margin: [0, 0, 0, 0],
                columns: [
                    {
                        style: "tableExample2",
                        table: {
                            headerRows: 1,
                            widths: [275],
                            heights: [100],
                            //keepWithHeaderRows: 1,
                            body: itemBodyObservation,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                    },
                    {
                        style: "tableExample3",
                        table: {
                            headerRows: 1,
                            widths: [120, 120],
                            //keepWithHeaderRows: 1,
                            body: itemBodyTotals,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                        relativePosition: { x: -10 }
                    }
                ]
            },
            {
                text: "\nSon: " + NumberToLetters(obj.neto.toString(), {
                    plural: 'PESOS',
                    singular: 'PESO',
                }) + "\n",
                fontSize: 9,
            },
            validateFooterAutorization(obj),


        ],
        styles: {
            head: {
                fontSize: 14,
                margin: [0, 0, 0, 0],
            },
            texthead: {
                fontSize: 10,
                margin: [0, 0, 0, 0],
            },
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 3, 0, 3],
                fontSize: 9
            },
            tableExample2: {
                margin: [0, 3, 0, 3],
                fontSize: 9
            },
            tableExample3: {
                margin: [0, 3, 0, 3],
                fontSize: 9,
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
            textInfoInvoice: {
                fontSize: 8,
                lineHeight: 1
            }
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

const propsQRCode = async (urlDian) => {
    if (urlDian != null) {
        return {
            image: await getBase64ImageFromURL("https://api.qrserver.com/v1/create-qr-code/?data=" + urlDian),
            width: 100,
            height: 100,
        }
    }
    else {
        return {}
    }
}
export default generateDocDefTemplate2;